export class FieldsConsultHelper {
  /**
   * Les champs du Form pour les controls
   */
  protected readonly FIELD_FIRST_NAME = 'first_name';
  protected readonly FIELD_LAST_NAME = 'last_name';
  protected readonly FIELD_OFFICE = 'office';
  protected readonly FIELD_PHONENUMBER = 'phone_number';
  protected readonly FIELD_TYPOLOGIE = 'typologie';
  protected readonly FIELD_DETAILS = 'details';
  protected readonly FIELD_YEAR_MIN = 'year_min';
  protected readonly FIELD_YEAR_MAX = 'year_max';
  protected readonly FIELD_SVC = 'svc';
  protected readonly FIELD_DIR_CMP = 'dir_cmp';
  /**
   * les champs Form effectifs à prendre en compte pour le modèle Loaning
   * sont-ils obligatoires (valeur) pour l'envoi de la demande ? true | false
   * syntaxiquement, l'utilisation de [] ([this.FIELD]) est nécessaire dans le cas de constante avec une propriété "string"
   * @example
   *  [{ 'dir_cmp': true }, {'svc': false}] : dir_cmp est obligatoire à l'envoi, svc n'est pas obligatoire à l'envoi
   * */
  protected fieldsForm = [
    { [this.FIELD_DIR_CMP]: true},
    { [this.FIELD_SVC]: false},
    { [this.FIELD_OFFICE]: true},
    { [this.FIELD_PHONENUMBER]: true},
    { [this.FIELD_FIRST_NAME]: true},
    { [this.FIELD_LAST_NAME]: true},
    { [this.FIELD_YEAR_MIN]: true},
    { [this.FIELD_YEAR_MAX]: false},
    { [this.FIELD_TYPOLOGIE]: true},
    { [this.FIELD_DETAILS]: true},
  ];
  /**
   * La longueur max de certains champs
   */
  protected maxLengthProperties: Map<string, number> = new Map<string, number>([
    [this.FIELD_FIRST_NAME, 150],
    [this.FIELD_LAST_NAME, 150],
    [this.FIELD_OFFICE, 150],
    [this.FIELD_PHONENUMBER, 20],
    [this.FIELD_TYPOLOGIE, 150],
    [this.FIELD_SVC, 150]
  ]);
}
